<template></template>
<script>
import {UserApi} from "@core/api";
import useJwt from "@/auth/jwt/useJwt";

const loading = document.getElementById('loading-bg');
export default {
    methods: {
        appendOrganizationToStore(organization) {
            let organizations = this.$store.state.user.organizations;
            let found = organizations.find(o => o.id === organization.id);
            if (found === undefined) {
                organizations.push(organization);
                this.$store.commit(
                    'setOrganizations',
                    organizations
                );
            }
        },
        handleTokenAlreadyUsedCase() {
            let isUserLogged = useJwt.hasToken();
            let message = 'Link you are trying to use to get into your account is not longer valid. You will be redirected to login page.';

            if (isUserLogged) {
                message = 'Link you are trying to use to get into your account is not longer valid. You will be redirected to homepage.';
            }

            this.$swal({
                title: 'Link usage error',
                text: message,
                allowOutsideClick: false,
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: true,
            }).then(() => {
                this.$router.push({name: isUserLogged ? 'homepage' : 'login'});
            });
        }
    },
    created() {
        if (loading) {
            loading.style.display = 'block';
        }

        let token = this.$route.query.t;
        let route = useJwt.hasToken() ? 'received-requests' : 'homepage';

        if (token) {
            useJwt.clear();
            UserApi.swiftLogin(token).then(r => {
                this.$store.dispatch('swiftLoginSuccessful');

                useJwt.setToken(r.data.token)
                useJwt.setRefreshToken(r.data.refresh_token)

                if (r.data.route) {
                    route = r.data.route;
                }

                if (r.data.appendOrganization) {
                    this.appendOrganizationToStore(r.data.organization);
                }

                this.$store
                    .dispatch('setOrganization', r.data.organization)
                    .then(() => {
                        this.$router.push({name: route});
                    })
                ;
            }).catch(error => {
                if (error.response) {
                    if (error.response.data.detail === 'token: Not found') {
                        this.handleTokenAlreadyUsedCase();
                    } else if (error.response.status === 422 && error.response.data instanceof Array && error.response.data.length > 0) {
                        if (error.response.data[0].propertyPath === 'token') {
                            this.handleTokenAlreadyUsedCase();
                        }
                    }
                }
            });
        }
    }
}
</script>
